import { render } from "./ControlWrapper.vue?vue&type=template&id=4712782a&scoped=true"
import script from "./ControlWrapper.vue?vue&type=script&lang=js"
export * from "./ControlWrapper.vue?vue&type=script&lang=js"

import "./ControlWrapper.vue?vue&type=style&index=0&id=4712782a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4712782a"]])

export default __exports__